const Alumni = () => {
    return (
      <div>
        <h1>Alumni</h1>
        {/* Content goes here */}
      </div>
    );
};

export default Alumni;